<template>
  <div>
  <h1 class="page-title display-1">{{ capitalize(pluralName) }}</h1>
  <visible-for v-show="display" superadmin administrator supervisor>
    <vuetify-crud-datatable
      slot="content"
      :name="name"
      :plural-name="pluralName"
      :rows-per-page-items='rowsPerPage'
      :translations="translations"
      :headers="item.headers || []"
      :rows="item.items || []"
      :actions="false"
      :item-key="item.item_value"
      :pagination="item.pagination"
      :defaultColumns="item.default_columns || {}"
      :primary-color="color.primary"
      :checkbox-color="color.checkbox"
      :primary-button-color="color.button.primary"
      :secundary-button-color="color.button.secundary"
      @on-edit="onEditItem"
      @on-delete="onDeleteItem"
      @on-add="onAddItem"
      @on-change-columns="onChangeColumns"
      :selected-columns="selectedColumns"
    ></vuetify-crud-datatable>
  </visible-for>
  <pre>

  </pre>
</div>
</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import VuetifyCrudDatatable from '@/components/vuetify-crud-datatable'

  export default {
    mixins: [Rule],

    components:
    {
      VisibleFor,
      VuetifyCrudDatatable
    },

    data () {
      return {
        taxonomyType: this.$route.params.type || '',
        name: '',
        pluralName: '',
        item: {},
        customColumnsResponse: null,
        selectedColumns: [],
        display: false,
        translations: {
          new: 'Nueva',
          delete_selecteds: 'Eliminar seleccionados',
          delete_element_message: 'Estás a punto de eliminar la',
          edit: 'Editar',
          cancel: 'Cancelar',
          delete: 'Eliminar',
          save: 'Guardar',
          delete_element: '¡ATENCIÓN!',
          search: 'Buscar',
          rows_per_page_items: 'Filas por página',
          no_results_text: 'No hay datos disponibles',
          no_data_text: 'No hay coincidencias',
          from: 'Desde',
          to: 'hasta',
          no_results_found_for: 'No se encontraron resultados para'
        },
        color: {
          checkbox: 'primary',
          primary: 'primary',
          success: 'success',
          error: 'error',
          button: {
            primary: 'primary',
            secundary: 'primary'
          }
        },
        rowsPerPage: [5, 10, 25, { 'text': 'Todas', 'value': -1 }]
      }
    },

    created () {
      this.getCustomColumns().then((response) => {
        this.getItems().then((response) => {
          // console.log(response)
          if (this.taxonomyType === 'observations') {
            this.item = this.normalizeObservations(response.data)
          } else if (this.taxonomyType === 'materials') {
            this.item = this.normalizeMaterials(response.data)
          } else if (this.taxonomyType === 'typess') {
            this.item = this.normalizeTypes(response.data)
          } else if (this.taxonomyType === 'exclusions') {
            this.item = this.normalizeExclusions(response.data)
          } else if (this.taxonomyType === 'inclusions') {
            this.item = this.normalizeInclusions(response.data)
          }
          this.display = true
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeObservations (item) {
        this.name = 'obsevación'
        this.pluralName = 'observaciones'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setObservationsDefaultColumns(item)
        item.headers = this.setObservationsHeaders(item)
        this.setObservationsTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeMaterials (item) {
        this.name = 'designación de material'
        this.pluralName = 'designaciones de material'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setMaterialsDefaultColumns(item)
        item.headers = this.setMaterialsHeaders(item)
        this.setMaterialsTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeTypes (item) {
        this.name = 'tipo de instalación'
        this.pluralName = 'tipos de instalación'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setTypesDefaultColumns(item)
        item.headers = this.setTypesHeaders(item)
        this.setTypesTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeExclusions (item) {
        this.name = 'exclusión'
        this.pluralName = 'exclusiones'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setExclusionsDefaultColumns(item)
        item.headers = this.setExclusionsHeaders(item)
        this.setExclusionsTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeInclusions (item) {
        this.name = 'inclusión'
        this.pluralName = 'inclusiones'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setInclusionsDefaultColumns(item)
        item.headers = this.setInclusionsHeaders(item)
        this.setInclusionsTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setPagination (item) {
        return {
          sortBy: item.item_value,
          descending: true,
          rowsPerPage: -1
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setObservationsDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setMaterialsDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: '',
          [item.item_text_2]: '',
          [item.item_text_3]: '',
          [item.item_text_4]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setTypesDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: '',
          [item.item_text_2]: '',
          [item.item_text_3]: '',
          [item.item_text_4]: '',
          [item.item_text_5]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setExclusionsDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setInclusionsDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setObservationsHeaders (item) {
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Observación',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setMaterialsHeaders (item) {
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Designación de material',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 1 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_2,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 2 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_3,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 3 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_4,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setTypesHeaders (item) {
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Tipo de instalación',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 1 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_2,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 2 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_3,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 3 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_4,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Duración (horas)',
            align: 'left',
            sortable: true,
            value: item.item_text_5,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setExclusionsHeaders (item) {
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Exclusión',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setInclusionsHeaders (item) {
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Inclusión',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/option/' + userID + '/' + this.taxonomyType + '_columns/'
          }).then((response) => {
            this.customColumnsResponse = response.data
            this.selectedColumns = JSON.parse(this.customColumnsResponse.user_option_value)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'put',
            url: 'user/option/' + userID + '/' + this.taxonomyType + '_columns/',
            data: {
              option_id: this.customColumnsResponse.user_option_id,
              option_value: JSON.stringify(this.selectedColumns)
            }
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al actualizar la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeColumns (customColumns) {
        this.selectedColumns = customColumns
        this.updateCustomColumns()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setObservationsTranslations () {
        this.translations.columns = 'Columnas'
        this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro'
        this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto'
        this.translations.restart_columns = 'Reiniciar columnas'
        this.translations.reset = 'Reiniciar'
        this.translations.new = 'Nueva'
        this.translations.delete_selecteds = 'Eliminar seleccionadas'
        this.translations.delete_element_message = 'Estás a punto de eliminar la'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setMaterialsTranslations () {
        this.translations.columns = 'Columnas'
        this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro'
        this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto'
        this.translations.restart_columns = 'Reiniciar columnas'
        this.translations.reset = 'Reiniciar'
        this.translations.new = 'Nueva'
        this.translations.delete_selecteds = 'Eliminar seleccionadas'
        this.translations.delete_element_message = 'Estás a punto de eliminar la'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setTypesTranslations () {
        this.translations.columns = 'Columnas'
        this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro'
        this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto'
        this.translations.restart_columns = 'Reiniciar columnas'
        this.translations.reset = 'Reiniciar'
        this.translations.new = 'Nuevo'
        this.translations.delete_selecteds = 'Eliminar seleccionados'
        this.translations.delete_element_message = 'Estás a punto de eliminar el'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setExclusionsTranslations () {
        this.translations.columns = 'Columnas'
        this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro'
        this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto'
        this.translations.restart_columns = 'Reiniciar columnas'
        this.translations.reset = 'Reiniciar'
        this.translations.new = 'Nueva'
        this.translations.delete_selecteds = 'Eliminar seleccionadas'
        this.translations.delete_element_message = 'Estás a punto de eliminar la'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setInclusionsTranslations () {
        this.translations.columns = 'Columnas'
        this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro'
        this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto'
        this.translations.restart_columns = 'Reiniciar columnas'
        this.translations.reset = 'Reiniciar'
        this.translations.new = 'Nueva'
        this.translations.delete_selecteds = 'Eliminar seleccionadas'
        this.translations.delete_element_message = 'Estás a punto de eliminar la'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getItems () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'installation/' + this.taxonomyType + '/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *pause_circle_filled
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (index) {
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'installation/' + this.taxonomyType + '/',
          data: this.getValues(index)
        }).then((response) => {
          // console.log(response.data)
          this.item.items[index][this.item.item_value] = response.data
          this.$store.dispatch(
            'snackbar/show',
            '¡Hecho!'
          )
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al guardar: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getValues (index) {
        if (this.taxonomyType === 'observations') {
          return {
            value: this.item.items[index][this.item.item_text]
          }
        } else if (this.taxonomyType === 'materials') {
          return {
            name: this.item.items[index][this.item.item_text],
            rate_1: this.item.items[index][this.item.item_text_2],
            rate_2: this.item.items[index][this.item.item_text_3],
            rate_3: this.item.items[index][this.item.item_text_4]
          }
        } else if (this.taxonomyType === 'types') {
          return {
            name: this.item.items[index][this.item.item_text],
            rate_1: this.item.items[index][this.item.item_text_2],
            rate_2: this.item.items[index][this.item.item_text_3],
            rate_3: this.item.items[index][this.item.item_text_4],
            duration: this.item.items[index][this.item.item_text_5]
          }
        } else if (this.taxonomyType === 'exclusions') {
          return {
            value: this.item.items[index][this.item.item_text]
          }
        } else if (this.taxonomyType === 'inclusions') {
          return {
            value: this.item.items[index][this.item.item_text]
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onEditItem (index) {
        let id = this.item.items[index][this.item.item_value]
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'installation/' + this.taxonomyType + '/' + id + '/',
          data: this.getValues(index)
        }).then((response) => {
          console.warn(response)
          this.$store.dispatch(
            'snackbar/show',
            '¡Hecho!'
          )
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al guardar: ' + this.$store.getters['api/getMessage']
          )
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDeleteItem (index) {
        let id = this.item.items[index][this.item.item_value]
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'installation/' + this.taxonomyType + '/' + id + '/'
        }).then((response) => {
          // console.log(response.data)
          this.$store.dispatch(
            'snackbar/show',
            '¡Hecho!'
          )
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al guardar: ' + this.$store.getters['api/getMessage']
          )
        })
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

</style>



// WEBPACK FOOTER //
// src/pages/taxonomies.vue